export const environment = {
  production: false,
  // tvmview-dev (backend runs with DOTNET_ENVIRONMENT=Staging there) — confirmed working
  // API Gateway domain for the portail-asct backend. Frontend and API are separate Nexum
  // apps on different domains, so this must be absolute (no reverse proxy stitches them together).
  apiBaseUrl: 'https://api.tvmview-dev.environments.apps.kubapay.io/api/v1',
  apiKey: 'f2d212b1-41b5-4fc2-9098-c4948e6f210e',
};
